import {
  DateTrunc,
  DateWindow,
  dateWindowOptions,
  defaultDateWindow,
  displayDateWindow,
} from '@tableau/metrics-engine';
import { DropdownButtonType, List, ListItem, SingleSelectDropdown } from '@tableau/widgets';
import * as React from 'react';
import { Messages } from '../../../../gen-src/Localize';
import { inputSection } from '../configurationStyles';
import { windowsMatch } from './DateWindowComponent';

export interface DateWindowTypeComponentProps {
  testId: string;
  className?: string;
  dateTrunc: DateTrunc;
  selectedDateWindow: DateWindow | null;
  isCustomWindowSelected: boolean;
  onChange: (value: DateWindow | null) => void;
  setCustomWindowSelected: (value: boolean) => void;
  disabled?: boolean;
  dropdownRef?: React.RefObject<HTMLButtonElement>;
}

export interface ListItemWithWindow extends ListItem {
  window?: DateWindow;
}

export const DateWindowTypeDropdownComponent = (props: DateWindowTypeComponentProps): JSX.Element => {
  let listItemsWithWindow: ListItemWithWindow[] = [];
  const [displayName, setDisplayName] = React.useState<string>('');

  React.useEffect(() => {
    if (!props.isCustomWindowSelected) {
      const defaultWindowForGranularity = defaultDateWindow(props.dateTrunc);
      const selectedDateWindow = props.selectedDateWindow ?? defaultWindowForGranularity;
      setDisplayName(displayDateWindow(selectedDateWindow));
      if (!windowsMatch(props.selectedDateWindow, selectedDateWindow)) {
        props.onChange(selectedDateWindow);
      }
    } else {
      setDisplayName(Messages.CustomOption());
    }
  }, [props.selectedDateWindow]);

  const updateStateValue = (value: string) => {
    const window: DateWindow | null = listItemsWithWindow.find((item) => item.value === value)?.window ?? null;
    props.setCustomWindowSelected(value === Messages.CustomOption());
    props.onChange(window);
  };

  const getDateWindowDisplayList = (): ListItemWithWindow[] => {
    const dateWindows: readonly DateWindow[] = dateWindowOptions(props.dateTrunc);
    listItemsWithWindow = dateWindows.map((dateWindow) => ({
      value: displayDateWindow(dateWindow),
      window: dateWindow,
    }));

    listItemsWithWindow = listItemsWithWindow.concat({
      value: Messages.CustomOption(),
    });
    return listItemsWithWindow;
  };

  return (
    <SingleSelectDropdown
      {...{
        className: inputSection,
        testId: props.testId,
        type: DropdownButtonType.Outline,
        label: Messages.DateRange(),
        list: <List items={getDateWindowDisplayList()} />,
        onChange: updateStateValue,
        value: displayName,
        disabled: props.disabled,
        buttonRef: props.dropdownRef,
      }}
    />
  );
};
